// WCAG 2.1 contrast ratio utilities

function hexToSrgb(hex) {
  const h = hex.replace('#', '');
  return [
    parseInt(h.slice(0, 2), 16) / 255,
    parseInt(h.slice(2, 4), 16) / 255,
    parseInt(h.slice(4, 6), 16) / 255,
  ];
}

function luminance(hex) {
  if (!hex || hex.length < 7) return 0;
  const [rs, gs, bs] = hexToSrgb(hex);
  const r = rs <= 0.03928 ? rs / 12.92 : ((rs + 0.055) / 1.055) ** 2.4;
  const g = gs <= 0.03928 ? gs / 12.92 : ((gs + 0.055) / 1.055) ** 2.4;
  const b = bs <= 0.03928 ? bs / 12.92 : ((bs + 0.055) / 1.055) ** 2.4;
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

function contrastRatio(hex1, hex2) {
  const l1 = luminance(hex1);
  const l2 = luminance(hex2);
  const lighter = Math.max(l1, l2);
  const darker = Math.min(l1, l2);
  return (lighter + 0.05) / (darker + 0.05);
}

/**
 * Returns textColor if it has sufficient contrast against bgColor (WCAG AA 4.5:1).
 * Otherwise returns a safe fallback: white on dark backgrounds, navy on light ones.
 */
export function validateContrast(textColor, bgColor) {
  if (!textColor || !bgColor) return textColor;
  if (contrastRatio(textColor, bgColor) >= 4.5) return textColor;
  return luminance(bgColor) < 0.5 ? '#ffffff' : '#0d1f35';
}

export { luminance, contrastRatio };
